import { Divider, HStack, DataList, DataItem } from '@cad-arc';
import { Property } from '../../../../../fr-entity-panels/types';
import { CARD_CONTAINERS_PADDING } from '../constants';
import { EntityTypes, MergedEntityTypes } from '../../../../../fr-entity-panels/types';
import { EventDrugsDto, EventFirearmDto, EventOtherItemDto } from '@mark43/cad-api';

function FirearmExpandableContent({ firearm }: { firearm: EventFirearmDto }) {
    const {
        registrationNumber,
        identifier,
        identifierType,
        alterationIndicated,
        firearmType,
    } = firearm;

    return (
        <>
            <Divider />
            <HStack alignItems="flex-start" padding={CARD_CONTAINERS_PADDING} width="100%">
                <DataList style={{ width: '50%' }}>
                    <DataItem dataKey="Registration #">{registrationNumber}</DataItem>
                </DataList>
                <DataList style={{ width: '50%' }}>
                    <DataItem dataKey="Firearm Type">{firearmType?.label}</DataItem>
                </DataList>
            </HStack>
            <HStack alignItems="flex-start" padding={CARD_CONTAINERS_PADDING} width="100%">
                <DataList style={{ width: '50%' }}>
                    <DataItem dataKey="Identifier">{identifier}</DataItem>
                    <DataItem dataKey="Identifier Type">{identifierType?.label}</DataItem>
                </DataList>
                <DataList style={{ width: '50%' }}>
                    <DataItem dataKey="Alteration Indicated">
                        {alterationIndicated ? 'Yes' : 'No'}
                    </DataItem>
                </DataList>
            </HStack>
        </>
    );
}
function DrugExpandableContent({ drug }: { drug: EventDrugsDto }) {
    const { isPrecursorChemical, identifier, identifierType } = drug;
    return (
        <>
            <Divider />
            <HStack alignItems="flex-start" padding={CARD_CONTAINERS_PADDING} width="100%">
                <DataList style={{ width: '50%' }}>
                    <DataItem dataKey="Is Precursor Chemical">
                        {isPrecursorChemical === true ? 'Yes' : 'No'}
                    </DataItem>
                </DataList>
            </HStack>
            <HStack alignItems="flex-start" padding={CARD_CONTAINERS_PADDING} width="100%">
                <DataList style={{ width: '50%' }}>
                    <DataItem dataKey="Identifier">{identifier}</DataItem>
                    <DataItem dataKey="Identifier Type">{identifierType?.label}</DataItem>
                </DataList>
            </HStack>
        </>
    );
}
function OtherItemExpandableContent({ otherItem }: { otherItem: EventOtherItemDto }) {
    const { color, make, model, size, identifier, identifierType } = otherItem;
    return (
        <>
            <Divider />
            <HStack alignItems="flex-start" padding={CARD_CONTAINERS_PADDING} width="100%">
                <DataList style={{ width: '50%' }}>
                    <DataItem dataKey="Make">{make}</DataItem>
                    <DataItem dataKey="Model">{model}</DataItem>
                </DataList>
                <DataList style={{ width: '50%' }}>
                    <DataItem dataKey="Size">{size}</DataItem>
                    <DataItem dataKey="Color">{color?.label}</DataItem>
                </DataList>
            </HStack>
            <HStack alignItems="flex-start" padding={CARD_CONTAINERS_PADDING} width="100%">
                <DataList style={{ width: '50%' }}>
                    <DataItem dataKey="Identifier">{identifier}</DataItem>
                    <DataItem dataKey="Identifier Type">{identifierType?.label}</DataItem>
                </DataList>
            </HStack>
        </>
    );
}

export function PropertyCardExpandableContent({
    property,
    entityType,
}: {
    property: Property;
    entityType: EntityTypes | MergedEntityTypes;
}) {
    if (entityType.includes('firearms') || entityType.includes('mergedFirearms')) {
        return <FirearmExpandableContent firearm={property as EventFirearmDto} />;
    }

    if (entityType.includes('drugs') || entityType.includes('mergedDrugs')) {
        return <DrugExpandableContent drug={property as EventDrugsDto} />;
    }

    if (entityType.includes('otherItems') || entityType.includes('mergedOtherItems')) {
        return <OtherItemExpandableContent otherItem={property as EventOtherItemDto} />;
    }

    return <></>;
}
